import React from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";


/**
 * Deprecated, use haven-design for new code
 * */
export class InputDatePicker extends React.Component {
  constructor (props) {
    super(props);
    const { formData, name } = this.props;
    if (!formData[name]) {
      this.state = { selected: null };
      return;
    }

    // Extract the year, month, and day to avoid converting a GMT Datetime to
    // the local time, potentially changing the date altogether.
    const datetime = formData[name];
    const selected = moment.utc(datetime);
    this.state = {
      selected: new Date(selected.year(), selected.month(), selected.date()),
    };
  }

  value () {
    // checking for valid date prior to submitting:
    if (this.state.selected instanceof Date && !isNaN(this.state.selected.getTime())) {
      return this.state.selected.toISOString();
    }

    return "";
  }

  render () {
    const { name, label, required, margin } = this.props;
    return (
      <div className="form-group">
        <KeyboardDatePicker
          id={name}
          style={{ minWidth: "15em", margin: ".5em 0" }}
          disableFuture={label === "Date of Birth"}
          required={!!required}
          autoComplete="off"
          autoOk
          variant="inline"
          inputVariant="outlined"
          margin={margin || "dense"}
          label={label}
          format="MM/dd/yyyy"
          InputAdornmentProps={{ position: "end" }}
          name="temp-input" // used to omit field when parsing form
          value={this.state.selected}
          onChange={date => this.setState({ selected: date })}
        />
        <input readOnly type="hidden" name={name} value={this.value()} />
      </div>
    );
  }
}
